module.exports = __webpack_public_path__ + "static/media/silkycloud-silver-5.ebfd0328.png";